﻿
import {
    trigger,
    style,
    animate,
    transition,
    state,
    keyframes,
    group
} from '@angular/animations';

// page-level animations
const pageAnimationDuration = 250;
const pageAnimationDistance = 3;

export const pageAnimatedContent = trigger('pageAnimatedContent', [
    state('out, void', style({
        opacity: 0,
        transform: `translateX(-${pageAnimationDistance}px) rotate(90deg) translateX(${pageAnimationDistance}px) rotate(-90deg)`
        //transform: 'translateX(-2.5%) translateY(2.5%)'
    })),
    state('in', style({
        opacity: 1,
        transform: `translateX(-${pageAnimationDistance}px) rotate(0deg) translateX(${pageAnimationDistance}px) rotate(-0deg)`
        //transform: 'translateX(0) translateY(0)'
    })),
    transition('void => in, out => in', [
        animate(pageAnimationDuration)
    ])
]);

export const pageAnimatedHeader = trigger('pageAnimatedHeader', [
    state('out, void', style({
        opacity: 0,
        transform: `translateX(${pageAnimationDistance}px) rotate(90deg) translateX(-${pageAnimationDistance}px) rotate(-90deg)`
        //transform: 'translateX(2.5%) translateY(-2.5%)'
    })),
    state('in', style({
        opacity: 1,
        transform: `translateX(${pageAnimationDistance}px) rotate(0deg) translateX(-${pageAnimationDistance}px) rotate(-0deg)`
        //transform: 'translateX(0) translateY(0)'
    })),
    transition('void => in, out => in', [
        animate(pageAnimationDuration)
    ])
]);
